import {GroupRole} from './GroupRole';

const isEnableAgentTicketsOrResourcesLink = (
  groupRole?: GroupRole,
  groupValue?: boolean,
  agentValue?: boolean
) => {
  if (agentValue === false) {
    return false;
  }
  if (groupValue ?? true) {
    return true;
  }
  if (agentValue === undefined) {
    return groupRole === GroupRole.administrator;
  }
  return agentValue;
};

export const isEnableAgentTicketsLink = (
  groupRole?: GroupRole,
  groupEnableAgentTicketsLink?: boolean,
  agentEnableAgentTicketsLink?: boolean
) => {
  return isEnableAgentTicketsOrResourcesLink(
    groupRole,
    groupEnableAgentTicketsLink,
    agentEnableAgentTicketsLink
  );
};

export const isEnableMerchantTicketsLinkForAgent = (
  groupEnableMerchantTicketsLink?: boolean,
  agentEnableMerchantTicketsLink?: boolean
) => {
  if (agentEnableMerchantTicketsLink === undefined) {
    return groupEnableMerchantTicketsLink ?? true;
  }
  return agentEnableMerchantTicketsLink;
};

export const isEnableAgentResourcesLink = (
  groupRole?: GroupRole,
  groupEnableAgentResourcesLink?: boolean,
  agentEnableAgentResourcesLink?: boolean
) => {
  return isEnableAgentTicketsOrResourcesLink(
    groupRole,
    groupEnableAgentResourcesLink,
    agentEnableAgentResourcesLink
  );
};

export const isEnableRiskApplicationClassification = (
  groupEnableRiskApplicationClassification?: boolean,
  agentEnableRiskApplicationClassification?: boolean
) => {
  if (agentEnableRiskApplicationClassification === false) {
    return false;
  }
  return groupEnableRiskApplicationClassification === true;
};
